import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["activeKey", "onTabClick", "onTabDrop"];
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Tabs } from "./Tabs.js";
import { Provider } from "./store.js";
import { useEventCallback } from "./hooks.js";
import { jsx as _jsx } from "react/jsx-runtime";
export * from "./Tab.js";
export * from "./hooks.js";
var TabContainer = _ref => {
  var activeKey = _ref.activeKey,
    onTabClick = _ref.onTabClick,
    onTabDrop = _ref.onTabDrop,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var tabClick = useEventCallback(onTabClick);
  var tabDrop = useEventCallback(onTabDrop);
  return /*#__PURE__*/_jsx(DndProvider, {
    backend: HTML5Backend,
    context: window,
    children: /*#__PURE__*/_jsx(Provider, {
      init: {
        data: [],
        activeKey,
        onTabClick: tabClick,
        onTabDrop: tabDrop
      },
      children: /*#__PURE__*/_jsx(Tabs, _extends({}, props, {
        activeKey: activeKey
      }))
    })
  });
};
export default TabContainer;